import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PaymentHistoryView from 'views/customers/paymenthistory'; // Importing PaymentHistoryView component

/**
 * PayHistoryView class extends JetView to create a payment history view.
 */
export default class PayHistoryView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view layout.
     */
    config() {
        return {
            type: 'wide', // Sets the type of layout to 'wide'
            cols: [PaymentHistoryView, PersonsView], // Defines columns with PaymentHistoryView and PersonsView
        };
    }

    /**
     * Lifecycle method called when the view is ready.
     * Triggers an event indicating that the payment history is ready.
     */
    ready() {
        this.app.callEvent('payment:history:ready'); // Calls the event to signal readiness
    }
}

// FILE DOCUMENTED
